import { cloneDeep, get, isEqual } from 'lodash';

/** @return Value specified by path if all objects have the same value. Otherwise, null. */
export const getIfCommonWith = (objects, path) => {
  if (!objects || objects.length < 1 || !path) { return null; }
  const value = cloneDeep(get(objects[0], path));
  const isAnyObjectValueNotEqual = objects.some((object, index) => {
    if (index !== 0) {
      const compareValue = get(object, path);
      if (!isEqual(value, compareValue)) { return true; } // At least one object has a differing value.
    }
    return false;
  });
  return isAnyObjectValueNotEqual ? null : value;
};
